import { escapeHtml, formatAlertsTooltipHtml } from "../../../../../utils/formatters";

export function buildPlanMapRouteTooltipHtml(route) {
  const routeName = escapeHtml(route?.routeName || route?.name || "Ruta", "Ruta");
  const stopCount = escapeHtml(route?.stopCount || "0", "0");
  const routeDistance = escapeHtml(route?.routeDistance || "0 km", "0 km");
  const routeTimeWindow = escapeHtml(route?.routeTimeWindow || "-", "-");
  const routeTotalTime = escapeHtml(route?.routeTotalTime || "0 min", "0 min");
  const warningContent = formatAlertsTooltipHtml(route?.alerts || route?.warningText);

  return `
    <div class="map-stop-popup">     
      <div><strong>Ruta:</strong> ${routeName}</div>     
      <div><strong>Paradas:</strong> ${stopCount}</div>
      <div><strong>Distancia:</strong> ${routeDistance}</div>
      <div><strong>Horario:</strong> ${routeTimeWindow}</div>
      <div><strong>Duracion:</strong> ${routeTotalTime}</div>
      ${warningContent ? `<div><strong>Alerta:</strong> ${warningContent}</div>` : ""}
    </div>
  `;
}

export function buildPlanMapStopTooltipHtml(route, stop) {
  const routeName = escapeHtml(route?.routeName || route?.name || "Ruta", "Ruta");
  const orderLabel = escapeHtml(stop?.orderLabel || stop?.label || "-", "-");
  const statusLabel = escapeHtml(stop?.statusLabel || stop?.status || "Pendiente", "Pendiente");
  const contact = escapeHtml(stop?.contact);
  const address = escapeHtml(stop?.address || "-", "-");
  const timeWindow1 = escapeHtml(stop?.timeWindow1Label || stop?.timeWindow1 || "-", "-");
  const timeWindow2 = escapeHtml(stop?.timeWindow2Label || stop?.timeWindow2 || "-", "-");
  const warningContent = formatAlertsTooltipHtml(stop?.alerts);

  return `
    <div class="map-stop-popup">
      <div><strong>Parada:</strong> ${orderLabel}</div>
      <div><strong>Ruta:</strong> ${routeName}</div>     
      <div><strong>Estado:</strong> ${statusLabel}</div>
      <div><strong>Cliente:</strong> ${contact}</div>
      <div><strong>Direccion:</strong> ${address}</div>
      <div><strong>Horario 1:</strong> ${timeWindow1}</div>
      <div><strong>Horario 2:</strong> ${timeWindow2}</div>
      ${warningContent ? `<div><strong>Alerta:</strong> ${warningContent}</div>` : ""}
    </div>
  `;
}
